import FirstBlogPost from '../posts/sample.md';
import FirstBlogPostImage from '../assets/img/post_1.png'

const Posts = [
    {
        title: "La Naturaleza del Ser: Reflexiones Ontológicas",
        date: "10 de Septiembre, 2025",
        description: "Una exploración profunda sobre la pregunta fundamental de la filosofía: ¿qué significa existir? Desde Parménides hasta Heidegger.",
        image: FirstBlogPostImage,
        content: "/posts/naturaleza-del-ser.md",
        route: "naturaleza-del-ser",
        category: "Metafísica",
        tags: ["ontología", "ser", "existencia", "Parménides", "Heidegger"]
    },
    {
        title: "El Problema del Conocimiento y sus Límites",
        date: "8 de Septiembre, 2025",
        description: "¿Qué podemos conocer realmente? Un análisis epistemológico desde los escépticos griegos hasta la filosofía contemporánea.",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop",
        content: "/posts/conocimiento-y-limites.md",
        route: "conocimiento-y-limites",
        category: "Epistemología",
        tags: ["conocimiento", "escepticismo", "límites", "epistemología", "certeza"]
    },
    {
        title: "Ética y Moral: El Fundamento de Nuestras Acciones",
        date: "6 de Septiembre, 2025",
        description: "Explorando las bases de la conducta humana a través de Aristóteles, Kant y las corrientes éticas modernas.",
        image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=600&h=400&fit=crop",
        content: "/posts/etica-y-moral.md",
        route: "etica-y-moral",
        category: "Ética",
        tags: ["moral", "virtud", "Aristóteles", "Kant", "imperativo categórico"]
    },
    {
        title: "La Cuestión del Sentido en la Existencia Humana",
        date: "4 de Septiembre, 2025",
        description: "¿Tiene la vida un propósito inherente? Reflexiones existencialistas desde Kierkegaard hasta Sartre y Camus.",
        image: "https://images.unsplash.com/photo-1618944847023-38aa001235f8?w=600&h=400&fit=crop",
        content: "/posts/cuestion-del-sentido.md",
        route: "cuestion-del-sentido",
        category: "Antropología Filosófica",
        tags: ["existencialismo", "sentido", "absurdo", "Kierkegaard", "Sartre", "Camus"]
    },
    {
        title: "Filosofía Política: Justicia, Poder y Sociedad",
        date: "2 de Septiembre, 2025",
        description: "Análisis de las estructuras sociales y políticas desde Platón hasta Rawls, explorando conceptos de justicia y poder.",
        image: "https://images.unsplash.com/photo-1589578527966-fdac0f44566c?w=600&h=400&fit=crop",
        content: "/posts/filosofia-politica.md",
        route: "filosofia-politica",
        category: "Filosofía Política",
        tags: ["justicia", "poder", "Estado", "Platón", "Rawls", "contrato social"]
    },
    {
        title: "El Tiempo y la Eternidad: Perspectivas Filosóficas",
        date: "31 de Agosto, 2025",
        description: "¿Qué es el tiempo? Una investigación filosófica sobre la temporalidad desde Agustín de Hipona hasta la física cuántica.",
        image: "https://images.unsplash.com/photo-1501139083538-0139583c060f?w=600&h=400&fit=crop",
        content: "/posts/tiempo-y-eternidad.md",
        route: "tiempo-y-eternidad",
        category: "Metafísica",
        tags: ["tiempo", "eternidad", "temporalidad", "Agustín", "física cuántica"]
    },
    {
        title: "Estética y Filosofía del Arte",
        date: "29 de Agosto, 2025",
        description: "¿Qué hace que algo sea bello? Una investigación sobre la naturaleza estética y la experiencia artística.",
        image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=600&h=400&fit=crop",
        content: "/posts/estetica-filosofia-arte.md",
        route: "estetica-filosofia-arte",
        category: "Estética",
        tags: ["belleza", "arte", "experiencia estética", "juicio estético", "estética"]
    },
    {
        title: "Filosofía de la Mente: Conciencia y Realidad",
        date: "27 de Agosto, 2025",
        description: "El enigma de la conciencia: ¿cómo surge la experiencia subjetiva? Explorando el problema mente-cuerpo.",
        image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-de-la-mente",
        category: "Antropología Filosófica",
        tags: ["conciencia", "mente-cuerpo", "qualia", "dualismo", "materialismo"]
    },
    {
        title: "Libertad y Determinismo: El Debate Milenario",
        date: "25 de Agosto, 2025",
        description: "¿Somos realmente libres o todo está predeterminado? Un análisis del libre albedrío y sus implicaciones.",
        image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "libertad-y-determinismo",
        category: "Metafísica",
        tags: ["libre albedrío", "determinismo", "causalidad", "libertad", "responsabilidad"]
    },
    {
        title: "Filosofía de la Ciencia: Método y Conocimiento",
        date: "23 de Agosto, 2025",
        description: "Examinando los fundamentos del conocimiento científico. De Bacon y Galileo hasta Popper y Kuhn.",
        image: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-de-la-ciencia",
        category: "Epistemología",
        tags: ["ciencia", "método científico", "Popper", "Kuhn", "falsabilidad"]
    },
    {
        title: "El Lenguaje y la Realidad: Filosofía Analítica",
        date: "21 de Agosto, 2025",
        description: "¿Cómo el lenguaje construye nuestra comprensión del mundo? Wittgenstein, Russell y la revolución lingüística.",
        image: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "lenguaje-y-realidad",
        category: "Epistemología",
        tags: ["lenguaje", "Wittgenstein", "Russell", "filosofía analítica", "significado"]
    },
    {
        title: "Fenomenología: La Experiencia Vivida",
        date: "19 de Agosto, 2025",
        description: "Husserl y la descripción de la conciencia. Explorando cómo percibimos y experimentamos el mundo.",
        image: "https://images.unsplash.com/photo-1517077304055-6e89abbf09b0?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "fenomenologia-experiencia",
        category: "Antropología Filosófica",
        tags: ["fenomenología", "Husserl", "conciencia", "intencionalidad", "experiencia"]
    },
    {
        title: "Nihilismo y Posmodernidad: Crisis de Valores",
        date: "17 de Agosto, 2025",
        description: "Nietzsche, la muerte de Dios y las consecuencias del nihilismo en la cultura contemporánea.",
        image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "nihilismo-posmodernidad",
        category: "Ética",
        tags: ["nihilismo", "Nietzsche", "valores", "posmodernidad", "crisis"]
    },
    {
        title: "Filosofía Oriental: Sabiduría del Este",
        date: "15 de Agosto, 2025",
        description: "Budismo, Taoísmo y Hinduismo: perspectivas orientales sobre la existencia y la iluminación.",
        image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-oriental",
        category: "Antropología Filosófica",
        tags: ["budismo", "taoísmo", "hinduismo", "iluminación", "sabiduría oriental"]
    },
    {
        title: "Filosofía Feminista: Género y Conocimiento",
        date: "13 de Agosto, 2025",
        description: "Simone de Beauvoir, Judith Butler y las perspectivas feministas en la filosofía contemporánea.",
        image: "https://images.unsplash.com/photo-1594736797933-d0b22d60d6ad?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-feminista",
        category: "Filosofía Política",
        tags: ["feminismo", "género", "Simone de Beauvoir", "Judith Butler", "igualdad"]
    },
    {
        title: "Tecnología y Humanidad: Reflexiones Éticas",
        date: "11 de Agosto, 2025",
        description: "¿Cómo la tecnología transforma nuestra humanidad? Filosofía de la técnica en la era digital.",
        image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "tecnologia-humanidad",
        category: "Ética",
        tags: ["tecnología", "humanidad", "ética digital", "técnica", "transformación"]
    },
    {
        title: "La Muerte y el Sentido de la Vida",
        date: "9 de Agosto, 2025",
        description: "Reflexiones filosóficas sobre la mortalidad. Desde Epicuro hasta Levinas y la ética del rostro.",
        image: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "muerte-sentido-vida",
        category: "Antropología Filosófica",
        tags: ["muerte", "mortalidad", "Epicuro", "Levinas", "finitud"]
    },
    {
        title: "Filosofía del Derecho: Justicia y Legalidad",
        date: "7 de Agosto, 2025",
        description: "¿Qué hace justo a un sistema legal? Hart, Dworkin y las teorías contemporáneas del derecho.",
        image: "https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-derecho",
        category: "Filosofía Política",
        tags: ["derecho", "justicia", "legalidad", "Hart", "Dworkin"]
    },
    {
        title: "Filosofía Medieval: Fe y Razón",
        date: "5 de Agosto, 2025",
        description: "Agustín, Tomás de Aquino y la síntesis entre filosofía griega y pensamiento cristiano.",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-medieval",
        category: "Epistemología",
        tags: ["fe", "razón", "Agustín", "Tomás de Aquino", "escolástica"]
    },
    {
        title: "Pragmatismo Americano: Verdad y Utilidad",
        date: "3 de Agosto, 2025",
        description: "Pierce, James y Dewey: la filosofía como herramienta para la acción y la resolución de problemas.",
        image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "pragmatismo-americano",
        category: "Epistemología",
        tags: ["pragmatismo", "verdad", "utilidad", "Pierce", "James", "Dewey"]
    },
    {
        title: "Filosofía de la Historia: Progreso y Destino",
        date: "1 de Agosto, 2025",
        description: "¿Tiene la historia una dirección? Hegel, Marx y las interpretaciones del devenir histórico.",
        image: "https://images.unsplash.com/photo-1618944847023-38aa001235f8?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-historia",
        category: "Filosofía Política",
        tags: ["historia", "progreso", "Hegel", "Marx", "dialéctica"]
    },
    {
        title: "Bioética: Vida, Medicina y Moral",
        date: "30 de Julio, 2025",
        description: "Dilemas éticos en medicina y biotecnología. Peter Singer, Tom Beauchamp y los principios bioéticos.",
        image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "bioetica-medicina",
        category: "Ética",
        tags: ["bioética", "medicina", "vida", "Singer", "Beauchamp", "principios"]
    },
    {
        title: "Filosofía Ambiental: Naturaleza y Responsabilidad",
        date: "28 de Julio, 2025",
        description: "Aldo Leopold, Arne Naess y la ética ecológica. Nuestra relación con el medio ambiente.",
        image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-ambiental",
        category: "Ética",
        tags: ["medio ambiente", "ecología", "Leopold", "Naess", "sostenibilidad"]
    },
    {
        title: "Postcolonialismo: Identidad y Cultura",
        date: "26 de Julio, 2025",
        description: "Edward Said, Gayatri Spivak y las perspectivas postcoloniales en la filosofía contemporánea.",
        image: "https://images.unsplash.com/photo-1594736797933-d0b22d60d6ad?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "postcolonialismo-identidad",
        category: "Filosofía Política",
        tags: ["postcolonialismo", "identidad", "cultura", "Said", "Spivak"]
    },
    {
        title: "Filosofía de la Educación: Aprendizaje y Formación",
        date: "24 de Julio, 2025",
        description: "Dewey, Freire y las teorías educativas. ¿Cuál es el propósito de la educación en la sociedad?",
        image: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-educacion",
        category: "Filosofía Política",
        tags: ["educación", "aprendizaje", "Dewey", "Freire", "pedagogía"]
    },
    {
        title: "Hermenéutica: Interpretación y Comprensión",
        date: "22 de Julio, 2025",
        description: "Gadamer, Ricoeur y el arte de la interpretación. Cómo comprendemos textos y tradiciones.",
        image: "https://images.unsplash.com/photo-1517077304055-6e89abbf09b0?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "hermeneutica-interpretacion",
        category: "Epistemología",
        tags: ["hermenéutica", "interpretación", "Gadamer", "Ricoeur", "comprensión"]
    },
    {
        title: "Filosofía de la Religión: Fe, Razón y Trascendencia",
        date: "20 de Julio, 2025",
        description: "¿Puede la razón acceder a lo divino? Anselmo, Tomás de Aquino y los argumentos sobre Dios.",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-religion",
        category: "Metafísica",
        tags: ["religión", "Dios", "trascendencia", "Anselmo", "argumentos teológicos"]
    },
    {
        title: "Filosofía del Arte Contemporáneo: Vanguardias y Estética",
        date: "18 de Julio, 2025",
        description: "Benjamin, Adorno y la obra de arte en la era de la reproducción técnica. Arte y sociedad.",
        image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "arte-contemporaneo",
        category: "Estética",
        tags: ["arte contemporáneo", "Benjamin", "Adorno", "reproducción", "vanguardias"]
    },
    {
        title: "Filosofía Social: Individuo y Comunidad",
        date: "16 de Julio, 2025",
        description: "¿Cómo se relaciona el individuo con la sociedad? Durkheim, Weber y las teorías sociales.",
        image: "https://images.unsplash.com/photo-1589578527966-fdac0f44566c?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-social",
        category: "Filosofía Política",
        tags: ["sociedad", "individuo", "comunidad", "Durkheim", "Weber"]
    },
    {
        title: "Filosofía de la Psicología: Mente y Comportamiento",
        date: "14 de Julio, 2025",
        description: "Daniel Dennett, Jerry Fodor y las bases filosóficas de la psicología científica.",
        image: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=600&h=400&fit=crop",
        content: FirstBlogPost,
        route: "filosofia-psicologia",
        category: "Antropología Filosófica",
        tags: ["psicología", "mente", "comportamiento", "Dennett", "Fodor"]
    }
];

export default Posts;